import PropTypes from 'prop-types';
import React, { useRef, useState, useEffect } from 'react';
import { Card, Form, Col, Row } from 'react-bootstrap';
import useToken from 'hooks/useToken';
import Skeleton from 'react-loading-skeleton';
import NumberOfTicketsChart from './NumberOfTicketsChart';
import TicketsCategory from '../TicketsCategory';
import DatePicker from "react-datepicker";
import { useToast } from 'context/providers/ToastProvider';
const NumberOfTickets = ({
    agentesSoporte,
    cargandoAgentesSoporte
}) => {
    const [cargando, setCargando] = useState(false);
    const { setToken, token } = useToken();
    const chartRef = useRef(null);
    const [totalTickets, setTotalTickets] = useState(0);
    const [totalCustomers, setTotalCustomers] = useState(0);
    const [numbersOfTickets, setNumbersOfTickets] = useState([[]]);
    const [selectedUser, setSelectedUser] = useState(0);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const { showErrorToast } = useToast();
    //obtiene la tabla de soporte tecnico
    const GetNumbersOfTickets = async () => {
        setCargando(true);
        const formattedDate = new Date(selectedDate).toISOString().split('T')[0];
        const response = await fetch("/api/soportetecnico/GetNumbersOfTickets/?date=" + formattedDate + "&idUsuario=" + selectedUser,
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

        if (response.ok) {
            const data = await response.json();
            setTotalTickets(data['table1'][0].totalTickets);
            setTotalCustomers(data['table1'][0].totalCustomers);
            setNumbersOfTickets([data['table2'].map(row => row.TicketsPorDia)]);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargando(false);
    };

    useEffect(() => {
        GetNumbersOfTickets();
    }, [selectedDate, selectedUser]);

    return (
        <Card className="h-100">
            <Card.Header className="d-flex flex-column flex-md-row justify-content-between border-bottom border-200 py-3 py-md-2">
                <h6 className="mb-2 mb-md-0 py-md-2">Number of Tickets</h6>
                <div className="d-flex flex-column flex-sm-row gap-2">
                    <Col md="auto" className="mb-1 mt-1 mb-md-3">
                        <Row className="g-3 gy-md-0 h-100 align-items-center">
                            <Col xs="auto">
                    <Form.Select
                        size="sm"
                        value={selectedUser}
                        onChange={(e) => setSelectedUser(e.target.value === "" ? 0 : parseInt(e.target.value))}
                        style={{ minWidth: '150px' }}
                    >
                        <option value="">{cargandoAgentesSoporte ? 'Cargando agentes...' : 'Todos los agentes'}</option>
                        {agentesSoporte.map(agente => (
                            <option key={agente.idUsuario} value={agente.idUsuario}>
                                {agente.vNombre} {agente.vApellidos}
                            </option>
                        ))}
                                </Form.Select>
                            </Col>
                            <Col md="auto">
                    <DatePicker
                        selected={selectedDate}
                        onChange={(date) => {
                            console.log("date: ", date);
                            setSelectedDate(date);
                        }}
                        dateFormat="MMMM yyyy - QQQ"
                        className="form-control form-control-sm"
                        showMonthYearPicker
                        style={{ minWidth: '200px' }}
                                />
                            </Col>
                        </Row>
                    </Col>
                </div>
            </Card.Header>
            <Card.Body className="scrollbar overflow-y-hidden">
                <div className="d-flex flex-column flex-sm-row">
                    <div className="d-flex align-items-center mb-2 mb-sm-0">
                        {cargando ?
                            <Skeleton  width={100} height={50} className="mb-1" />
                            :
                            <TicketsCategory
                                title="Total Tickets"
                                number={totalTickets}
                                percentage="5.3%"
                                icon="caret-up"
                                badgeColor="text-success"
                            />
                        }
                        <div
                            className="bg-200 mx-3 d-none d-sm-block"
                            style={{ height: '24px', width: '1px' }}
                        ></div>
                    </div>
                    <div className="d-flex align-items-center">
                        {cargando ?
                            <Skeleton width={100} height={50} className="mb-1" />
                            : <TicketsCategory
                                title="Total Customers"
                                number={totalCustomers}
                                percentage="2.6%"
                                icon="caret-up"
                                badgeColor="text-success"
                            />
                        }
                        <div
                            className="bg-200 mx-3 d-none d-sm-block"
                            style={{ height: '24px', width: '1px' }}
                        ></div>
                    </div>
                </div>
                {cargando ?
                    <Skeleton  height={300} className="mb-1" />
                    :
                    <NumberOfTicketsChart data={numbersOfTickets} mes={selectedDate} ref={chartRef} />
                }
            </Card.Body>
            <Card.Footer className="bg-light py-2">

            </Card.Footer>
        </Card>
    );
};

NumberOfTickets.propTypes = {
    agentesSoporte: PropTypes.array,
    cargandoAgentesSoporte: PropTypes.bool
};

export default NumberOfTickets;
